import axios from 'axios'

export function getTopicsList (first_view_flag = '1') {
  return new Promise(function (resolve, reject) {
    callApi(process.env.GET_TOPICS_LIST, first_view_flag)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function getNoticeList (first_view_flag = '1') {
  return new Promise(function (resolve, reject) {
    callApi(process.env.GET_NOTICE_LIST, first_view_flag)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function getNewsList (first_view_flag = '1') {
  return new Promise(function (resolve, reject) {
    callApi(process.env.GET_NEWS_LIST, first_view_flag)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function getUrgentList (first_view_flag = '1') {
  return new Promise(function (resolve, reject) {
    callApi(process.env.GET_URGENT_LIST, first_view_flag)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function getCampaignList (first_view_flag = '1') {
  return new Promise(function (resolve, reject) {
    callApi(process.env.GET_CAMPAIGN_LIST, first_view_flag)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

export function getCampaignBannerList (first_view_flag = '1') {
  return new Promise(function (resolve, reject) {
    callApi(process.env.GET_CAMPAIGN_BANNER_LIST, first_view_flag)
      .then(res => { resolve(res) })
      .catch(error => { reject(error) })
  })
}

function callApi (url, firstViewFlag) {
  return new Promise(function (resolve, reject) {
    let data = {
      first_view_flag: firstViewFlag
    }
    axios.post(url, JSON.stringify(data), {headers: {'Content-Type': 'application/json'}})
      .then(res => {
        let result = res.data
        // console.log('res', result)
        if (result.status === 1) {
          reject(new Error(result.error_message))
        }
        resolve(result)
      })
      .catch(error => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/CmsHelper.js